import { Content } from '@tiptap/react';
import { ForwardedRef, useImperativeHandle } from 'react';

import { UseActionInputState } from '../../../hooks/use-action-input-state';
import { ActionData } from '../../../lib/entities';
import { RichMediaState } from '../../../lib/state';
import { Validation, ValidationError } from '../../../lib/validation';
import { actionData } from '../../../utils/data';

interface UseActionHandlersOptions {
	editor: any;
	inputState: RichMediaState;
	reset: VoidFunction;
	setErrors: (errors: ValidationError[]) => void;
	state: UseActionInputState;
}

export interface ActionInputHandle {
	data: () => ActionData;
	error: (...errors: (string | ValidationError)[]) => void;
	focus: VoidFunction;
	insert: (content: Content) => void;
	reset: VoidFunction;
}

export const useActionHandle = (ref: ForwardedRef<any>, { editor, inputState, reset, setErrors, state }: UseActionHandlersOptions) => {
	useImperativeHandle(ref, () => ({
		data: () => {
			return actionData({
				...state,
				state: inputState,
			});
		},
		error: (...errors: (string | ValidationError)[]) => {
			const validations = errors.map((error) => {
				if (error instanceof ValidationError) {
					return error;
				}

				return new ValidationError(Validation.ServerError, error);
			});

			setErrors(validations);
		},
		focus: () => {
			editor?.commands.focus();
		},
		insert(content: Content) {
			editor?.commands.insertContent(content);
		},
		reset: () => {
			editor?.commands.clearContent();
			reset();
		},
	}));
};
